import { defineComponent } from 'vue'

import PointsPage from '@/organizations/_default/points'
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'
import Page from "@/services/Page.js"

export default defineComponent({
  extends: PointsPage,
  components: { 
    CosmoHeader, 
    CosmoFooter,
  },
  setup(props, context) {
    const page = PointsPage.setup(props, context)

    // アプリ用に引き継ぐクエリを追加指定
    const queries = ['btn', 'sh', 'once', 'frm', 'skip', 'view']
    queries.forEach((query) => {
      Page.forwardQueries[query] = {}
    })

    return {
      ...page,
    }
  }
})
